import { twMerge } from 'tailwind-merge'

/**
 * Склейка классов Tailwind: последний спорящий выигрывает.
 *
 * Почему не просто join через пробел, как было раньше. В атрибуте class порядок
 * слов ничего не решает — спор одинаковых по весу правил CSS разрешает порядком
 * в собранном файле стилей. У Tailwind этот порядок задан его собственной
 * шкалой, а не нашим кодом: `.h-full` стоит после `.h-14`, поэтому компонент,
 * поставивший себе `h-full` по умолчанию, молча побеждал любой размер,
 * переданный снаружи.
 *
 * Ломается это тихо и не везде: класс, попавший в CSS раньше, проигрывает,
 * попавший позже — выигрывает, и оба случая выглядят как «иногда работает».
 * Так на планшете рисунок переговорной раздулся на всю карточку и выдавил
 * текст: `RoomImage` держал `h-full w-full`, а карточка просила `h-14 w-20`.
 *
 * twMerge знает шкалу Tailwind и выбрасывает проигравший класс совсем:
 * cn('h-full w-full', 'h-14 w-20') === 'h-14 w-20'. Правило простое —
 * побеждает тот, кто передан позже, то есть вызывающий код.
 *
 * Оговорка: twMerge разбирает только классы Tailwind. Свои имена
 * (`card`, `hint`, `tnum` из index.css) он не трогает и не сортирует —
 * они просто проезжают насквозь.
 */
export function cn(...values: Array<string | false | null | undefined>): string {
  return twMerge(values.filter(Boolean).join(' '))
}
